import { action, makeObservable, observable } from "mobx";
import CommonStore from "../../stores/CommonStore";
import { ProductOrderService } from "../../service/ProductOrderService";
import ProductOrderProfitOverviewResponse from "../../model/productOrder/ProductOrderProfitOverviewResponse";

class ProfitsStore {
    public commonStore: CommonStore;
    public from: number | undefined;
    public to: number | undefined;

    public profitsSummary: ProductOrderProfitOverviewResponse | undefined = undefined;
    public selectedService: string | null = null;
    public isLoading: boolean = false;

    constructor(commonStore: CommonStore) {
        this.commonStore = commonStore;
        this.from = Date.now() - 15 * 24 * 60 * 60 * 1000; // Últimos 15 dias
        this.to = Date.now();

        makeObservable(this, {
            from: observable,
            to: observable,
            profitsSummary: observable,
            selectedService: observable,
            isLoading: observable,
            
            setDateRange: action,
            setProfitsSummary: action,
            loadProfits: action,
        });
    }

    get totalProfit(): number {
        return this.profitsSummary?.totalProfit || 0;
    }

    get totalOrders(): number {
        return this.profitsSummary?.ordersAmount || 0;
    }

    public setFromFilter(from: number | undefined) {
        this.from = from;
    }

    public setToFilter(to: number | undefined) {
        this.to = to;
    }

    public setDateRange(from: number, to: number) {
        this.from = from;
        this.to = to;
    }

    public setProfitsSummary(summary: ProductOrderProfitOverviewResponse | undefined) {
        this.profitsSummary = summary;
    }

    @action
    public async loadProfits() {
        try {
            console.log(this.from, this.to);
            this.isLoading = true;
            this.commonStore.setLoading();
            
            // TODO: Chamar o endpoint que retorna os lucros
            // const response = await ProfitsService.getProfits(this.from, this.to);
            // if (response.success) {
            //     this.setProfitsSummary(response.data);
            // }
            if (this.from && this.to) {
                const response = await ProductOrderService.getProfitOverview(this.from, this.to);
                if (response.success) {
                    this.setProfitsSummary(response.data);
                }
            }
            
            this.commonStore.removeLoading();
        } catch (error) {
            this.commonStore.removeLoading();
            console.error("Erro ao carregar lucros:", error);
        } finally {
            this.isLoading = false;
        }
    }
}

export default ProfitsStore;
